import { Directive } from '@angular/core';

@Directive({
  selector: '[switch]'
})
export class SwitchInputDirective {}
